import { motion, AnimatePresence } from 'framer-motion'

import { Friend } from '@/domain/entities/friend.entity'
import { formatStatusStudent } from '@/utils/formatting/statusStudent'

import styles from './styles.module.scss'

interface IProps {
  friend: Friend
  indicatorId: string
}

export const IndicationList = ({ friend, indicatorId }: IProps) => {
  return (
    <AnimatePresence mode="wait">
      {indicatorId === friend.id && (
        <tr className={styles.indications_row}>
          <td colSpan={10}>
            <motion.div
              className={styles.indications}
              initial={{ opacity: 0, maxHeight: 0 }}
              animate={{ opacity: 1, maxHeight: 500 }}
              exit={{ opacity: 0, maxHeight: 0 }}
              transition={{ duration: 0.4, ease: 'easeInOut' }}
            >
              <h3>Indicações de {friend.name}</h3>
              {friend.students.length > 0 ? (
                friend.students.map((student) => (
                  <div key={student.id} className={styles.student}>
                    <p>
                      <strong>Nome:</strong> {student.alunonome}
                    </p>
                    <p>
                      <strong>Email:</strong> {student.responsavelemail}
                    </p>
                    <p>
                      <strong>Status do aluno:</strong>{' '}
                      <span
                        className={
                          student.status === 'approved'
                            ? styles.approved
                            : styles.reproved
                        }
                      >
                        {formatStatusStudent(student.status)}
                      </span>
                    </p>
                  </div>
                ))
              ) : (
                <p>Nenhuma indicação encontrada</p>
              )}
            </motion.div>
          </td>
        </tr>
      )}
    </AnimatePresence>
  )
}
